import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getLaborDetail, addLabor } from '../../../actions/laborsActions'
import { getCrops } from '../../../actions/cropsActions'
import FormLabor from '../../admin/labors/FormLabor'
import Swal from 'sweetalert2'

export default function LaborInsert() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {labor} = useSelector(state=>state.labors)
    const {crops} = useSelector(state=>state.crops)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, description, require_machinery, cropslist} = formState
    const [imageAux, setImage] = useState(null)

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

	const changeImage = (e) => {
		setImage(e.target.files[0])
	}

    const handleAdd = async(e) => {
        e.preventDefault()

        dispatch(addLabor(name, description, cropslist, require_machinery, imageAux))
        setFormState({
            name: '',
            description: '',
            cropslist: [],
            require_machinery: false
        })
		setImage(null)
        
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('labors.add')
        })
    }

    useEffect(()=>{
        dispatch(getLaborDetail(id))
        dispatch(getCrops())
    }, [dispatch,id])

    useEffect(() => {
        if (labor) {
            setFormState({
                name: '',
                description: '',
                cropslist: [],
                require_machinery: false
            })
        }
    }, [labor, dispatch, id])

    const handleCheckboxChange  = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.checked
        })
    }
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/labors`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('labors.volver')}
                    </Button>
                </Row>
                <h1>{t('labors.add')}</h1>
                <FormLabor submit={handleAdd} isNew={true} inputChange={handleInputChange} handleCheckbox={handleCheckboxChange} changeImage={changeImage} imageAux={imageAux} state={formState} crops={crops}></FormLabor>
            </Row>
        </Container>
    )
}
